var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FeatureFlags } from "./featureFlags";
import { isCI, isDevelopment } from "../helpers";
export var getFeatureFlag = function (featureName, sourceFeatureFlags) {
    var featureFlag = sourceFeatureFlags[featureName];
    // In development or CI, if the feature flag is not set, default to true
    if (isCI() || isDevelopment()) {
        if (featureFlag) {
            return featureFlag === "true";
        }
        return true;
    }
    // In the cloud envs, if the feature flag is not set, default to false
    return featureFlag === "true";
};
export var featureFlags = Object.keys(FeatureFlags).reduce(function (acc, featureFlag) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[featureFlag] = getFeatureFlag(featureFlag, FeatureFlags), _a)));
}, {});
